import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/price-lists'

class PriceListDataService extends RestApiDataService {

}

export default new PriceListDataService(BASE_ENTITY_URL)
